import React from 'react'

import useStyles from '../Footer.styles'

export default function FooterSocial () {
  const classes = useStyles()
  
  return (
    <>
      <div
        style={{ fontSize: 12, marginBottom: 8 }}
        className={`col d-flex justify-content-start align-items-center px-5 ${classes.text}`}
      >
        ©{new Date().getFullYear()} Multikrd LLC. All rights reserved
      </div>
      <div
        style={{ fontSize: 12, marginBottom: 8 }}
        className={`col d-flex justify-content-start align-items-center px-5 ${classes.text}`}
      >
        Apple, the Apple logo and Apple Wallet are trademarks of Apple Inc., registered in the U.S.
        and other countries. App Store is a service mark of Apple Inc., registered in the U.S. and
        other countries.
      </div>
      <div
        style={{ fontSize: 12, marginBottom: 8 }}
        className={`col d-flex justify-content-start align-items-center px-5 ${classes.text}`}
      >
        Google Play, the Google Play logo, and Google Wallet are trademarks of Google LLC.
      </div>
      <div
        style={{ fontSize: 12, textAlign: 'left' }}
        className={`col d-flex justify-content-start align-items-center px-5 pb-3 ${classes.text}`}
      >
        The Multikrd Prepaid Mastercard is issued by Central Bank of Kansas City, Member FDIC,
        pursuant to a license by Mastercard® International Incorporated. Mastercard® is a registered
        trademark, and the circles design is a trademark of Mastercard International Incorporated.
        Certain fees, terms, and conditions are associated with the approval, maintenance, and use
        of the Card. You should consult your Cardholder Agreement and the Fee Schedule. If you have
        any questions regarding the Card or such fees, terms, and conditions, you can contact us
        toll-free at 1-866-995-2736, we are available 24/7/365.
      </div>
      <div
        style={{ fontSize: 12, textAlign: 'left' }}
        className={`col d-flex justify-content-start align-items-center px-5 pb-3 ${classes.text}`}
      >
        The Multikrd Payroll Mastercard is issued by Central Bank of Kansas City, Member FDIC, pursuant to a license by Mastercard International Incorporated. Mastercard is a registered trademark, and the circles design is a trademark of Mastercard International Incorporated. Certain fees, terms, and conditions are associated with the approval, maintenance, and use of the Card. You should consult your Cardholder Agreement and Fee Schedule. If you have any questions regarding the Card or such fees, terms, and conditions, you can contact us toll-free at 1-866-995-2736, we are available 24/7/365.
      </div>
    </>
  )
}
